module.exports = __webpack_public_path__ + "static/media/fileIcon.c0702f1d.svg";